module.exports = __webpack_public_path__ + "img/logout.6554bca4.png";